import { RouteConfig } from "./types";
import { Suspense } from "react";
import { LazyLoading } from "@/controls/LazyLoading";
import HeatReport from "@/pages/heat-report";

export const heatReportRoutes: RouteConfig[] = [
  {
    path: "/heat-process-report",
    element: <HeatReport />,
    permission: "ui.navbar.meltshop",
  },
  {
    path: "/heat-process-report/:asset",
    element: (
      <Suspense fallback={<LazyLoading />}>
        <HeatReport />
      </Suspense>
    ),
    permission: "ui.navbar.meltshop",
  },
];
